import { Us, Tr } from "svelte-flags";

import { resolve } from "$app/paths";

import { m } from "$lib/paraglide/messages.js";
import { localizeHref } from "$lib/paraglide/runtime";

export const languages = [
  {
    code: "en",
    iso: "en-US",
    name: "English",
    native: "English",
    dir: "ltr",
    path: "/en/",
    flag: Us,
  },
  {
    code: "tr",
    iso: "tr-TR",
    name: "Turkish",
    native: "Türkçe",
    dir: "ltr",
    path: "/tr/",
    flag: Tr,
  },
];

export const navigations = {
  items: [
    // {
    //   title: "Home",
    //   href: "/",
    // },
    {
      title: m.nav_posts(),
      href: localizeHref("/posts/"),
    },
    {
      title: m.nav_about(), // "About",
      href: localizeHref("/about/"),
    },
    {
      title: m.nav_contact(), // "Contact",
      href: localizeHref("/contact/"),
    },
  ],
};

export const socialMediaLinks = {
  items: [
    {
      icon: "Github",
      title: "Github",
      href: "https://github.com/alisamar",
    },
    {
      icon: "Linkedin",
      title: "Linkedin",
      href: "https://www.linkedin.com/in/alisamar",
    },
    {
      icon: "Mastodon",
      title: "Mastodon",
      href: "https://mastodon.social/@alisamar",
    },
  ],
};

export const footerNavigations = {
  items: [
    {
      title: m.footer_nav_home(),
      href: localizeHref("/"),
    },
    {
      title: m.nav_posts(),
      href: localizeHref("/posts/"),
    },
    {
      title: m.nav_about(), // "About",
      href: localizeHref("/about/"),
    },
    {
      title: m.nav_contact(), // "Contact",
      href: localizeHref("/contact/"),
    },
    // {
    //   title: "Changelog",
    //   href: "/changelog/",
    // },
  ],
};

export const footerBottomNavigations = [
  // {
  //   title: "Terms",
  //   href: "#",
  // },
  {
    title: m.footer_nav_privacy(),
    href: resolve(localizeHref("/privacy/")),
  },
  {
    title: m.footer_nav_status(),
    href: "https://alisamar.instatus.com/",
  },
  {
    title: m.footer_nav_changelog(),
    href: resolve(localizeHref("/changelog/")),
  },
];

export * from "./techStack.js";
